import AxiosInterceptor from "../../AxiosInterceptorAlcohol";

// 메모 조회
// request data
//  - pid
//  - page
export function getMemoFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/memo',
        method: 'get',
        params: request
    })
}


// 메모 작성
// request data
//  - pid
//  - memoInfo
export function postMemoToAlcohol(request) {
    return AxiosInterceptor({
        url: '/memo',
        method: 'post',
        data: request
    })
}